import React from "react";
import styled from "styled-components";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import toast from "react-hot-toast";
import { useUnosPositionAdd } from "hooks/unos/position/useUnosPositionAdd";
import { QUERY_KEYS } from "constant/react_query";
import PositionForm from "components/common/position/PositionForm/PositionForm";
import { useNavigate } from "react-router-dom";
import { positionFormDefaultValuesGet } from "common/position/position_form_common";

const PositionNew = () => {
  const { handleSubmit, reset, control, setValue } = useForm({
    defaultValues: positionFormDefaultValuesGet(),
  });
  const navigate = useNavigate();
  const { positionAddMutate } = useUnosPositionAdd({
    invalidateKeys: [QUERY_KEYS.UNOS_POSITION_SEARCH],
    successHandle: (id: any) => {
      console.log("add success", id);
      navigate(`/position/${id}`);
    },
  });

  const onSubmit = async (data: any) => {
    console.log(data);
    const { datum, title, fileName } = data;

    console.log("datum", datum);
    const res = positionAddMutate({ datum, title, fileName });
    toast.success("New position added");
  };

  return (
    <>
      <div>Position Add</div>
      <DivPosition>
        <PositionForm
          control={control}
          onSubmit={onSubmit}
          handleSubmit={handleSubmit}
          reset={reset}
          setValue={setValue}
        />
      </DivPosition>
    </>
  );
};

const DivPosition = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  column-gap: 2rem;
  row-gap: 2rem;
  margin-top: 2rem;
`;

export default PositionNew;
